<template>
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6">
    <h3 class="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
      <span>📈</span>
      <span>四维度得分详情</span>
    </h3>

    <div class="space-y-6">
      <!-- 成熟偏好 -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <span class="text-2xl">🎓</span>
            <span class="font-semibold text-gray-900">成熟偏好</span>
          </div>
          <span class="text-2xl font-bold text-psychology-primary">{{ scores.MAT }}</span>
        </div>
        <div class="relative h-4 bg-gray-100 rounded-full overflow-hidden">
          <div 
            class="absolute top-0 left-0 h-full bg-gradient-to-r from-psychology-primary to-psychology-primary-light rounded-full transition-all duration-1000"
            :style="{ width: scores.MAT + '%' }"
          ></div>
        </div>
        <p class="text-xs text-gray-600 mt-1">{{ getDimensionDescription('MAT', scores.MAT) }}</p>
      </div>

      <!-- 照顾需求 -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <span class="text-2xl">💝</span>
            <span class="font-semibold text-gray-900">照顾需求</span>
          </div>
          <span class="text-2xl font-bold text-purple-600">{{ scores.CAR }}</span>
        </div>
        <div class="relative h-4 bg-gray-100 rounded-full overflow-hidden">
          <div 
            class="absolute top-0 left-0 h-full bg-gradient-to-r from-purple-500 to-purple-300 rounded-full transition-all duration-1000"
            :style="{ width: scores.CAR + '%' }"
          ></div>
        </div>
        <p class="text-xs text-gray-600 mt-1">{{ getDimensionDescription('CAR', scores.CAR) }}</p>
      </div>

      <!-- 引导欲望 -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <span class="text-2xl">🌟</span>
            <span class="font-semibold text-gray-900">引导欲望</span>
          </div>
          <span class="text-2xl font-bold text-amber-600">{{ scores.GUI }}</span>
        </div>
        <div class="relative h-4 bg-gray-100 rounded-full overflow-hidden">
          <div 
            class="absolute top-0 left-0 h-full bg-gradient-to-r from-amber-500 to-amber-300 rounded-full transition-all duration-1000"
            :style="{ width: scores.GUI + '%' }"
          ></div>
        </div>
        <p class="text-xs text-gray-600 mt-1">{{ getDimensionDescription('GUI', scores.GUI) }}</p>
      </div>

      <!-- 独立倾向 -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <span class="text-2xl">🦋</span>
            <span class="font-semibold text-gray-900">独立倾向</span>
          </div>
          <span class="text-2xl font-bold text-cyan-600">{{ scores.IND }}</span>
        </div>
        <div class="relative h-4 bg-gray-100 rounded-full overflow-hidden">
          <div 
            class="absolute top-0 left-0 h-full bg-gradient-to-r from-cyan-500 to-cyan-300 rounded-full transition-all duration-1000"
            :style="{ width: scores.IND + '%' }"
          ></div>
        </div>
        <p class="text-xs text-gray-600 mt-1">{{ getDimensionDescription('IND', scores.IND) }}</p>
      </div>
    </div>

    <!-- 说明 -->
    <div class="mt-6 p-4 bg-gray-50 rounded-lg">
      <p class="text-sm text-gray-600">
        <strong>💡 提示:</strong> 
        成熟偏好和照顾需求分数越高,年上倾向越强;
        引导欲望和独立倾向分数越高,年下倾向越强。
      </p>
    </div>
  </div>
</template>

<script>
import { getDimensionLevel } from '@/utils/aypCalculator'

export default {
  name: 'DimensionScoresBars',
  props: {
    scores: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.MAT !== undefined && 
               value.CAR !== undefined && 
               value.GUI !== undefined && 
               value.IND !== undefined
      }
    }
  },
  methods: {
    getDimensionDescription(dimension, score) {
      const level = getDimensionLevel(score)
      const descriptions = {
        MAT: {
          '非常高': '你非常看重伴侣的成熟度和人生经验',
          '较高': '你比较欣赏成熟稳重的伴侣',
          '中等': '你对伴侣的成熟度持中立态度',
          '较低': '你不太在意伴侣的年龄和成熟度',
          '非常低': '你更喜欢年轻有活力的伴侣'
        },
        CAR: {
          '非常高': '你非常渴望在关系中被照顾和呵护',
          '较高': '你比较享受被伴侣照顾的感觉',
          '中等': '你对被照顾的需求适中',
          '较低': '你比较独立,不太需要被照顾',
          '非常低': '你非常独立,不依赖伴侣照顾'
        },
        GUI: {
          '非常高': '你非常享受引导和照顾伴侣',
          '较高': '你比较喜欢在关系中扮演引导者',
          '中等': '你对引导伴侣的欲望适中',
          '较低': '你不太倾向主导关系',
          '非常低': '你更愿意被伴侣引导'
        },
        IND: {
          '非常高': '你非常重视个人空间和独立性',
          '较高': '你比较需要保持独立性',
          '中等': '你在独立和亲密间保持平衡',
          '较低': '你不太介意与伴侣亲密无间',
          '非常低': '你非常愿意与伴侣融为一体'
        }
      }
      return descriptions[dimension]?.[level] || ''
    }
  }
}
</script>

